export {default} from '../../../core/components/Repository/FieldStaticValue';